import React, {useState} from 'react';
import {Modal} from 'reactstrap';
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import {RotateCircleLoading} from "react-loadingg";
import LoadingOverlay from "react-loading-overlay";
import Button from "reactstrap/es/Button";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

const BusinessPickModal = (props) => {
    const [visible, setVisible] = useState(true);
    const [loading, setLoading] = useState(false);

    const onDismiss = () => setVisible(false);

    const localize = () => {
        const loc = localeHelpers.currentLocale();
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    };

    localize();

    return (
        <Modal
            className="modal-dialog-centered modal-success"
            contentClassName="bg-gradient-success"
            isOpen={visible}
            toggle={props.toggleModal}
        >
            <LoadingOverlay
                active={loading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <div className="modal-header">
                    <h6 className="modal-title" id="modal-title-notification">
                        {commonStrings.navigation.switch_business}
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={props.toggleModal}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="py-3 text-center" style={{display: "flex", flexFlow: "column"}}>
                        {props.businesses && props.businesses.length > 1 && props.businesses.map((business, index) => {
                            return(
                                <Button onClick={e => props.setBusiness(business.id)} key={business.id} style={{margin: 10}}>{business.name}</Button>
                            )
                        })}
                    </div>
                </div>

            </LoadingOverlay>
        </Modal>
    );


};

export default BusinessPickModal;